import { EconomicsScenarioDetails, Id } from "PFTypes";

import api from "../../api";

export const deleteActivityEconomicsScenario = (scenarioId: Id) =>
  api<EconomicsScenarioDetails>({ url: `scenarios/${scenarioId}`, method: "DELETE" });
